import { useState } from 'react';
import { useFacingMode } from '@/hooks';
import UploadFaceCamera from '@/components/common/VideoCapture/UploadFaceCamera';
import { Flex } from '@/components';
import { Button } from 'antd';
import { convertFileToBase64 } from '@/utils/func';
import { useTranslation } from 'react-i18next';

export default function FaceEnrollmentImage({ uploading, handleUpload }) {

  const [t] = useTranslation(['common', 'face']);
  const { facingMode, toggleFacingMode } = useFacingMode();
  const [file, setFile] = useState<File>(null);

  return (
    <Flex direction="column">
      <UploadFaceCamera
        setFile={setFile}
        facingMode={facingMode}
        toggleFacingMode={toggleFacingMode}
      />
      <Button
        type="primary"
        loading={uploading}
        onClick={() => {
          convertFileToBase64(file as any).then(value => handleUpload(value));
        }}
        disabled={file == null}
        className="mt-auto mx-auto leading-none">{t('face:labels.upload-photo')}</Button>
    </Flex>
  );
}
